import TournamentPage, { getServerSideProps } from './index';

export { getServerSideProps };
export default TournamentPage;
